<template>
  <div>
    <div style="width: 350px; margin: 0 auto">
      <img :src="url" class="paytmimg" alt="" />
      <div
        class="caption"
        style="text-align: center; color: blue; margin-bottom: 10px"
      >
        <!-- Flat 0% Commission -->
      </div>
      <v-text-field
        type="number"
        style="width: 350px; margin: 0 auto; height: 60px"
        label="Amount"
        v-model="amount"
        solo
      />
      <div style="width: 100%; float: left; height: 80px">
        <v-btn
          color="primary"
          style="width: 350px; margin: 0 auto"
          @click="submit"
          >Proceed to add money</v-btn
        >
        <v-btn style="width: 350px; margin: 0 auto" color="error" flat>{{
          charge
        }}</v-btn>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent width="300"
      ><v-card color="primary" dark
        ><v-card-text
          >Please wait
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0" /></v-card-text></v-card
    ></v-dialog>
    <form action="https://securegw.paytm.in/theia/processTransaction" method="POST" ref="form">
      <input type='hidden' v-for="(item,key) in form" :name='key' :key="key" :value='item' >
    </form>
  </div>
</template>
<script>
import axios from "axios"
import moment from "moment";
export default {
  props: ["charge", "url"],
  data() {
    return {
      id: "",
      amount: "",
      dialog: false,
      mid: null,
      form: {}
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    base() {
      return this.$store.getters.paytm_pg
    },
  },
  methods: {
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type,
      });
    },
    async fetchMID() {
      const vm = this;
      let {base, user} = vm;
      let {phone, password, authkey} = user;
      let url = `${base}/MID?MobileNo=${phone}&Password=${password}&AuthKey=${authkey}&Source=JSON`
      vm.dialog = true;
      try{
        let {data} = await axios(url);
        vm.mid = data.message;
        // let ckeditor = document.createElement('script');  
        // ckeditor.setAttribute('src',"//cdn.ckeditor.com/4.6.2/full/ckeditor.js");
        // document.head.appendChild(ckeditor);
        console.log(vm.mid);
        vm.dialog = false;
      }catch(err) {
        vm.dialog = false;
        vm.notification("error", err.message)
      }
    },
    async submit() {
      const vm = this;
      let {user, base, mid, amount} = vm;
      let {phone, authkey,password}=user;
      if(user==null || !phone) return vm.notification("error","Login Required!")
      if(!amount) return vm.notification("error","Amount is Required!")
      try{
      vm.dialog = true;
      var params = {};
      let orderId = `${moment().format("YYYYMMDDHHmmss")}-${phone}-Recharge`;
      let url = `${base}CheckSum?OrderId=${orderId}&Amount=${amount}&MobileNo=${phone}&Password=${password}&AuthKey=${authkey}&Source=json`;
      let {data} = await axios(url);
      let {INDUSTRY_TYPE_ID, CALLBACK_URL,CHANNEL_ID,CHECKSUMHASH,WEBSITE} = data.data;
      params['MID'] = mid;
      params['WEBSITE'] = WEBSITE;
      params['CHANNEL_ID'] = CHANNEL_ID;
      params['INDUSTRY_TYPE_ID'] = INDUSTRY_TYPE_ID;
      params['ORDER_ID'] = orderId
      params['CUST_ID'] = phone;
      params['TXN_AMOUNT'] = `${amount}.00`;
      params['CALLBACK_URL'] = CALLBACK_URL;
      params['CHECKSUMHASH'] = CHECKSUMHASH;
      console.log(CALLBACK_URL)
      vm.form = params;        
      setTimeout( () => {
        vm.$refs.form.submit();
        vm.dialog = false;
      },1000)
      }catch(err) {
        vm.notification(err.message, "error");
        vm.dialog = false;
      }

    }
  },
  mounted(){ 
  this.fetchMID()
  }
};
</script>


<style scoped>
.paytmimg {
  width: 170px;
  margin-left: 85px;
}
</style>

